import { render, staticRenderFns } from "./UnityRating.vue?vue&type=template&id=2e0d2e74&"
import script from "./UnityRating.vue?vue&type=script&lang=js&"
export * from "./UnityRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports